import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function SeoGrowthInternalLinks({ links }) {
  return (
    <section className="rounded-3xl border border-border bg-card p-6 shadow-xl md:p-8">
      <h2 className="font-heading text-3xl font-black">Next planning step</h2>
      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {links.map((link) => (
          <Link key={`${link.href}-${link.label}`} to={link.href} className="group rounded-2xl border border-border bg-background p-4 text-sm font-bold text-foreground transition hover:border-primary hover:bg-primary/5">
            <span>{link.label}</span>
            <ArrowUpRight className="mt-3 h-4 w-4 text-primary transition group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </section>
  );
}